import type { IRoute } from '@/router/helpers'
import { ContentLayout, ManageLayout } from '@/layouts'

const route: IRoute = {
  path: 'manage',
  Component: ContentLayout,
  children: [
    {
      path: '',
      Component: ManageLayout,
      children: [
        {
          path: '',
          Component: lazy(() => import('@/views/manage/workbench')),
          meta: { title: '工作台' },
        },
        {
          path: 'sales-stats',
          Component: lazy(() => import('@/views/manage/sales-stats')),
          meta: { title: '销售统计' },
        },
        {
          path: 'promos',
          Component: lazy(() => import('@/views/manage/promos')),
          meta: { title: '专属推广码' },
        },
        {
          path: 'order',
          Component: lazy(() => import('@/views/manage/order')),
          meta: { title: '契约管理' },
        },
        {
          path: 'branch-order',
          Component: lazy(() => import('@/views/manage/branch-order')),
          meta: { title: '下属契约' },
        },
        {
          path: 'users-dls',
          Component: lazy(() => import('@/views/manage/members/dls')),
          meta: { title: '代理商成员管理' },
        },
        {
          path: 'take-order',
          Component: lazy(() => import('@/views/manage/take-order')),
          meta: { title: '在线接单' },
        },
        {
          path: 'wait-order',
          Component: lazy(() => import('@/views/manage/wait-order')),
          meta: { title: '待我执行' },
        },
        {
          path: 'execute-apply',
          Component: lazy(() => import('@/views/manage/execute-apply')),
          meta: { title: '执行申请' },
        },
        {
          path: 'execute-apply/new/:id',
          Component: lazy(() => import('@/views/manage/execute-apply/new')),
          meta: { title: '新增执行申请' },
        },
        {
          path: 'active-order',
          Component: lazy(() => import('@/views/manage/wait-order')),
          meta: { title: '执行管理' },
        },
        {
          path: 'users-fws',
          Component: lazy(() => import('@/views/manage/members/fws')),
          meta: { title: '服务商成员管理' },
        },
        {
          path: 'material/:id',
          Component: lazy(() => import('@/views/manage/material')),
          meta: { title: '上传执行材料' },
        },
        {
          path: 'settle-records',
          Component: lazy(() => import('@/views/manage/settle-records')),
          meta: { title: '结算记录' },
        },
      ],
    },
    {
      path: 'product/:id',
      Component: lazy(() => import('@/views/manage/order/product')),
      meta: { title: '商品服务详情' },
    },
    {
      path: 'payment/:id/:payType',
      Component: lazy(() => import('@/views/manage/order/payment/index')),
      meta: { title: '支付二维码详情' },
    },
    {
      path: 'order/:id',
      Component: lazy(() => import('@/views/manage/order/detail')),
      meta: { title: '契约管理详情' },
    },
    {
      path: 'order/bindcard/:id',
      Component: lazy(() => import('@/views/manage/order/bind-card')),
    },
    {
      path: 'order/error/:id',
      Component: lazy(() => import('@/views/manage/order/error')),
    },
    {
      path: 'branch-order/:id',
      Component: lazy(() => import('@/views/manage/branch-order/detail')),
      meta: { title: '下属契约详情' },
    },
    {
      path: 'wait-order/:id',
      Component: lazy(() => import('@/views/manage/wait-order/detail')),
      meta: { title: '待我执行详情' },
    },
    {
      path: 'active-order/:id',
      Component: lazy(() => import('@/views/manage/wait-order/detail')),
      meta: { title: '执行管理详情' },
    },
  ],
}

export default route
